<template>
  <div
    class="table-item-documents"
    title=" "
    v-on:click="
      (e) => {
        e.stopPropagation();
      }
    ">
    <div v-if="props.row.sessionStatutLabel !== 'Annulé'">
      <div
        v-if="actions.testPositionnement?.disponible"
        class="table-item-document"
        v-on:click="
          async () => {
            openParticipantPositionnementModal();
          }
        ">
        <div class="table-item-document-icon">
          <IconModify />
        </div>
        <span class="table-item-document-text">
          {{ actions.testPositionnement?.label }}
        </span>
      </div>
      <div
        v-if="actions.testValidationsAcquis?.disponible"
        class="table-item-document"
        v-on:click="
          async () => {
            openParticipantValidationAcquisModal();
          }
        ">
        <div class="table-item-document-icon">
          <div class="table-item-document-icon">
            <IconModify />
          </div>
        </div>
        <span class="table-item-document-text">
          {{ actions.testValidationsAcquis?.label }}
        </span>
      </div>
      <div
        v-if="actions.satisfaction?.disponible"
        class="table-item-document"
        v-on:click="
          async () => {
            openParticipantQuestionnaireSatisfactionModal();
          }
        ">
        <div class="table-item-document-icon">
          <div class="table-item-document-icon">
            <IconModify />
          </div>
        </div>
        <span class="table-item-document-text">
          {{ actions.satisfaction?.label }}
        </span>
      </div>
      <div
        v-if="actions.moduleElearning?.disponible"
        class="table-item-document"
        v-on:click="computeElearning">
        <div class="table-item-e-learning-icon-container">
          <div class="table-item-e-learning-icon">
            <IconOpenNewTab />
          </div>
        </div>
        <span class="table-item-document-text">
          {{ actions.moduleElearning?.label }}
        </span>
      </div>
      <div
        v-if="
          !actions.satisfaction?.disponible &&
          !actions.testPositionnement?.disponible &&
          !actions.testValidationsAcquis?.disponible &&
          !actions.moduleElearning?.disponible
        "
        class="table-item-document">
        <span class="table-item-document-text !text-refonte_blue-200"> - </span>
      </div>
    </div>
    <div
      v-else
      class="table-item-document">
      <span class="table-item-document-text !text-refonte_blue-200"> - </span>
    </div>
  </div>
  <RefonteModalPositionnementParticipant
    v-if="isParticipantPositionnementModalOpen"
    v-bind:show="isParticipantPositionnementModalOpen"
    v-bind:on_close="closeParticipantPositionnementModal"
    v-bind:formation="props.row" />
  <RefonteModalValidationAcquisParticipant
    v-if="isParticipantValidationAquisModalOpen"
    v-bind:show="isParticipantValidationAquisModalOpen"
    v-bind:on_close="closeParticipantValidationAcquisModal"
    v-bind:formation="props.row" />
  <RefonteModalQuestionnaireSatisfactionParticipant
    v-if="isParticipantQuestionnaireSatisfactionModalOpen"
    v-bind:show="isParticipantQuestionnaireSatisfactionModalOpen"
    v-bind:on_close="closeParticipantQuestionnaireSatisfactionModal"
    v-bind:formation="props.row" />
</template>

<script setup lang="ts">
  import { Formation } from '@/types/participant/formations-types';
  import IconModify from '@/assets/img/refonte/icons/action/icon-modify.svg?component';
  import IconOpenNewTab from '@/assets/img/refonte/icons/action/icon-open-new-tab.svg?component';
  import { ref } from 'vue';
  import RefonteModalPositionnementParticipant from '@/components/refonte/modals/refonte-modal-positionnement-participant.vue';
  import RefonteModalValidationAcquisParticipant from '@/components/refonte/modals/refonte-modal-validation-acquis-participant.vue';
  import RefonteModalQuestionnaireSatisfactionParticipant from '@/components/refonte/modals/refonte-modal-questionnaire-satisfaction-participant.vue';

  const isParticipantPositionnementModalOpen = ref<boolean>(false);
  const isParticipantValidationAquisModalOpen = ref<boolean>(false);
  const isParticipantQuestionnaireSatisfactionModalOpen = ref<boolean>(false);

  const props = withDefaults(
    defineProps<{
      row: Formation;
      refresh_rows: Function;
      on_complete?: Function;
      open_elearning_retractation_modal?: Function;
      open_elearning_module?: Function;
    }>(),
    {}
  );
  const { actions } = props.row;

  function openParticipantPositionnementModal() {
    isParticipantPositionnementModalOpen.value = true;
  }
  function closeParticipantPositionnementModal() {
    isParticipantPositionnementModalOpen.value = false;
    if (props.refresh_rows) {
      props.refresh_rows();
    }
  }

  function openParticipantValidationAcquisModal() {
    isParticipantValidationAquisModalOpen.value = true;
  }
  function closeParticipantValidationAcquisModal() {
    isParticipantValidationAquisModalOpen.value = false;
    if (props.refresh_rows) {
      props.refresh_rows();
    }
  }
  function openParticipantQuestionnaireSatisfactionModal() {
    isParticipantQuestionnaireSatisfactionModalOpen.value = true;
  }
  function closeParticipantQuestionnaireSatisfactionModal() {
    isParticipantQuestionnaireSatisfactionModalOpen.value = false;
    if (props.refresh_rows) {
      props.refresh_rows();
    }
  }
  const computeElearning = () => {
    if (
      props.row.elearningParticipantId &&
      props.row?.moduleElearning?.showRetractation &&
      props.open_elearning_retractation_modal
    ) {
      props.open_elearning_retractation_modal(props.row);
    } else if (props.open_elearning_module) {
      props.open_elearning_module(props.row);
    }
  };
</script>

<style lang="scss" scoped>
  .table-item-documents {
    @apply flex flex-col;
    gap: 6px;

    .table-item-document {
      @apply flex items-center;
      min-height: 20px;
      gap: 2px;

      .table-item-document-icon {
        @apply flex shrink-0 items-center justify-center;
        width: 20px;
        height: 20px;

        :deep(svg) {
          @apply text-refonte_blue-200;
          width: 20px;
          height: 20px;
        }
      }
      .table-item-document-text {
        @apply flex-grow text-refonte-black;
        font-size: 14px;
        font-weight: 400;
        line-height: 125%;
      }
      &:hover {
        .table-item-document-text {
          @apply underline;
        }
      }

      &.table-item-document-to-sign {
        .table-item-document-icon {
          :deep(svg) {
            @apply text-refonte-secondary;
          }
        }
        .table-item-document-text {
          @apply text-refonte-secondary;
        }
      }

      .table-item-e-learning-icon-container {
        @apply flex items-center justify-center;
        width: 20px;
        height: 20px;
        .table-item-e-learning-icon {
          @apply flex shrink-0 items-center justify-center;
          width: 16px;
          height: 16px;

          :deep(svg) {
            @apply text-refonte_blue-200;
          }
        }
      }
    }
  }
</style>
